export type PasswordResetForm = {
  username?: string;
  password?: string;
  otp?: string;
};

export type SubviewProps = {
  form: PasswordResetForm;
  setForm: (form: PasswordResetForm) => void;
  setError: (err: string) => void;
};

export enum ResetError {
  INVALID_USER = 'login.passwordReset.errors.invalidUser',
  INVALID_OTP = 'login.passwordReset.errors.invalidOTP',
  INVALID_PASSWORD = 'login.passwordReset.errors.invalidPassword',
  UNEXPECTED = 'login.passwordReset.errors.unexpected',
  RESET_NOT_POSSIBLE = 'login.passwordReset.errors.resetNotPossible',
  RESET_FAILED = 'login.passwordReset.errors.resetFailed',
  RETRY_OTP = 'login.passwordReset.errors.retryOTP',
}

export type LogicReturnType = Promise<ResetError | undefined>;
